import {
  $postJobsForm,
  $postAcademyForm
} from "@/utils/endpoints";


export const state = () => ({});

const getters = {};

const mutations = {};

const actions = {
  postJobsForm: async ({ commit }, payload) => { // eslint-disable-line
    return await $postJobsForm(payload);
  },
  postAcademyForm: async ({ commit }, payload) => { // eslint-disable-line
    return await $postAcademyForm(payload);
  },
};

const namespaced = true;

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced,
};
